import type { FaireProductEntity } from "../../entity_types/product";

export const p_5c9nyd8fhd: FaireProductEntity = {
  token: "p_5c9nyd8fhd",
  type: "product",
  name: "Fern Statement Wire Earrings",
  brandToken: "b_5814217e",
  brandName: "Michael Michaud",
  imageUrl:
    "https://cdn.faire.com/fastly/fe036e18de5810557db347435fa34dca6112e904629a2c37fc141c06d00f3b23.jpeg",
  galleryImageUrls: [],
  priceDollars: 60,
  description:
    "Cast bronze earrings feature a hand patina finish that emphasizes delicate fern detail and sculptural movement. These dangle earrings from Michael Michaud showcase botanical-inspired casting for lifelike texture and subtle shine, suitable for special occasions.",
  tags: [],
  msrpDollars: 150,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:28.592Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
